var React = require('react');

function ColorPicker (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.146.852a2.92 2.92 0 0 0-4.122 0l-.786.784a1.083 1.083 0 0 0-1.53 0 1.077 1.077 0 0 0 0 1.527l.255.254-8.498 8.48h-.001l-2.95 2.944a1.323 1.323 0 0 0-.388.878l-.007.157v.002L0 18.54a.443.443 0 0 0 .441.46h.02l1.415-.063.863-.038.391-.017c.433-.02.845-.2 1.151-.506L15.618 7.064l.212.212a1.08 1.08 0 0 0 1.53 0 1.077 1.077 0 0 0 0-1.526l.786-.785a2.904 2.904 0 0 0 0-4.113zM9.96 10.675l-3.981.749 6.494-6.48 1.616 1.611-4.129 4.12z","fill":"currentColor","fillRule":"nonzero"}));
}

ColorPicker.defaultProps = {"viewBox":"0 0 19 19","width":"19","height":"19"};

module.exports = ColorPicker;

ColorPicker.default = ColorPicker;
